import { Box, Typography, TextField, Grid, SelectChangeEvent, FormControl, Select, MenuItem } from '@mui/material';
import React, { useState, ChangeEvent, useContext } from 'react';
import KenButton from '../../GlobalComponents/KenButton';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { borderRadius } from '@mui/system';
import { TaskAddDetails } from '../../interfaces/MentorShip';
import dayjs, { Dayjs } from 'dayjs';
import { postMentorShipTask } from '../../Utils/apiService';
import { enqueueSnackbar } from 'notistack';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import { AuthUser } from '../../interfaces/Contexts';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '100%', sm: '100%', md: '100%', xl: '558px', lg: '558px' },
  height: { xs: '100%', sm: '100%', md: '100%', xl: '450px', lg: '450px' },
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '9px',
  p: 4,
};

const AddTaskModel = (props: any) => {
  const {
    state: { user },
  } = useContext(AuthContext);
  const { setTaskUpdateStatus } = props;
  const userData = user as AuthUser;
  const [status, setStatus] = React.useState('');
  const [priority, setPriority] = React.useState('');
  const [formData, setFormData] = useState<TaskAddDetails>({
    contactId: userData.applicantId,
    assignedTo: userData.applicantId,
    createdBy: userData.applicantId,
    subject: '',
    status: '',
    priority: '',
    description: '',
    dueDate: '',
  });
  const [selectedDate, setSelectedDate] = useState<string | null>(null);

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = event.target;
    console.log('name', name, value);
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleChangeStatus = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };
  const handleChangePriority = (event: SelectChangeEvent) => {
    setPriority(event.target.value as string);
  };
  const handleDateChange = (newDate: Dayjs | null) => {
    if (newDate) {
      setSelectedDate(newDate.format('YYYY-MM-DD'));
      setFormData({ ...formData, dueDate: newDate.format('YYYY-MM-DD') });
    } else {
      setSelectedDate(null);
    }
    console.log('Selected Date:', newDate?.format('YYYY-MM-DD'));
  };
  console.log('formData324', formData, selectedDate);

  const postTask = () => {
    const payload = {
      ...formData,
      status,
      priority,
    };
    postMentorShipTask(payload)
      .then((res) => {
        if (res?.data?.success == true) {
          setTaskUpdateStatus(true);
          props.handleClose();
          enqueueSnackbar({
            message: 'Task Added Sucessfully',
            variant: 'success',
            autoHideDuration: 1000,
          });
        } else {
          enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        }
      })
      .catch((err) => {
        enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        console.error(err);
      });
  };
  return (
    <div>
      <Box sx={style} className="scrollbar-cusgray">
        <Typography sx={{ fontSize: '15px', fontWeight: 500 }}>{props.name == 'add' ? 'Add Task' : 'Edit Task'}</Typography>
        <hr />
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, mt: 2 }}>Title</Typography>
            <TextField
              id="outlined-basic"
              size="small"
              placeholder="Enter title"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              variant="outlined"
              fullWidth
              sx={{
                mt: 2,
                '& .MuiOutlinedInput-input::placeholder': {
                  fontSize: '12px',
                },
              }}
            />
            <Typography sx={{ fontSize: '12px', fontWeight: 500, mt: 2 }}>Status</Typography>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={status}
                placeholder="Select"
                onChange={handleChangeStatus}
                size="small"
                sx={{
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#3061FF',
                  },
                  '& .MuiSelect-select': {
                    fontSize: '12px',
                  },
                }}
              >
                <MenuItem
                  value={'Active'}
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: 'transparent',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:active': {
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  Active
                </MenuItem>
                <MenuItem
                  value={'Pending'}
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: 'transparent',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:active': {
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  Pending
                </MenuItem>
                <MenuItem
                  value={'Completed'}
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: 'transparent',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:active': {
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  Completed
                </MenuItem>
              </Select>
            </FormControl>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, mt: 2 }}>Add Description</Typography>
            <TextField
              id="outlined-basic"
              placeholder="Enter Description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              variant="outlined"
              multiline
              rows={2}
              fullWidth
              sx={{
                mt: 2,
                '& .MuiOutlinedInput-input::placeholder': {
                  fontSize: '12px',
                },
              }}
              size="small"
            />
          </Grid>
          <Grid item xs={6}>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, mt: 2 }}>End Date</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker']} sx={{ width: '100%', mt: 1 }}>
                <DatePicker
                  label="Basic date picker"
                  value={selectedDate ? dayjs(selectedDate) : null}
                  onChange={handleDateChange}
                  sx={{ width: '100%' }}
                  slotProps={{
                    textField: {
                      size: 'small',
                      InputLabelProps: {
                        sx: {
                          fontSize: '12px',
                        },
                      },
                    },
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, mt: 2 }}>Priority</Typography>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={priority}
                placeholder="Select"
                onChange={handleChangePriority}
                size="small"
                sx={{
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#3061FF',
                  },
                  '& .MuiSelect-select': {
                    fontSize: '12px',
                  },
                }}
              >
                <MenuItem
                  value={'High'}
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: 'transparent',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:active': {
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  High
                </MenuItem>
                <MenuItem
                  value={'Medium'}
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: 'transparent',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:active': {
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  Medium
                </MenuItem>
                <MenuItem
                  value={'Low'}
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: 'transparent',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:active': {
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  Low
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'end' }}>
          <Grid item xs={6} />
          <Grid item xs={6}>
            <Box sx={{ display: 'flex', justifyContent: 'end' }}>
              <KenButton
                variant="text"
                sx={{
                  mt: 2,
                  borderRadius: '8px',
                  backgroundColor: 'none',
                  '&:hover': {
                    backgroundColor: 'transparent',
                  },
                  color: 'black',
                  width: 100,
                }}
                onClick={props.handleClose}
                fullWidth
              >
                <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Cancel</Typography>
              </KenButton>
              <KenButton
                variant="contained"
                onClick={postTask}
                style={{
                  width: '90px',
                  marginTop: 15,
                  borderRadius: '6px',
                  boxShadow: 'none',
                  '&:hover': {
                    boxShadow: 'none',
                  },
                }}
                fullWidth
              >
                <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Save</Typography>
              </KenButton>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default AddTaskModel;
